import React, { useState } from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import Button from 'components/Button';
import Slider from 'react-slick';
import Color from 'components/Color';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { getProductsByCategoryId } from 'selectors/inventory';
import Image from 'components/Image';
import {
  Card,
  DetailSection,
  Description,
  Size,
  Color as StyledColor,
  ColorWrapper,
  CardWrapper,
} from 'styles/pages/home/productDetails';

const settings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const ProductDetails = ({ onBack, toggleSignUpDialog, selectedCategoryId }) => {
  let products = useSelector((state) => state?.products?.data) || [];
  products = getProductsByCategoryId(products, selectedCategoryId);

  const [selectedProduct, setSelectedProduct] = useState(
    products?.length ? products[0] : {}
  );

  return (
    <div>
      <Button
        containerStyle={{
          backgroundColor: 'transparent',
          fontSize: '13px',
          borderRadius: '50px',
          padding: '12px',
          lineHeight: '1.5',
          color: '#000',
          margin: '7px',
        }}
        startIcon={<ArrowBackIcon />}
        variant='text'
        title='Go Back'
        onClick={() => _.isFunction(onBack()) && onBack()}
      />
      <Slider {...settings}>
        {products.map((p, index) => {
          const product = p.Product;

          return (
            <CardWrapper key={`product${index}`}>
              <Card
                className={
                  selectedProduct?.Product?.ID === product.ID ? 'active' : ''
                }
                onClick={() => setSelectedProduct(p)}>
                <div>
                  <Image
                    src={
                      selectedProduct?.Product?.ID === product.ID
                        ? selectedProduct?.Product?.MarketingImagePath
                        : product.MarketingImagePath
                    }
                    alt={product.DisplayName}
                  />
                </div>
                <h4>{product.DisplayName}</h4>
                <p>
                  Starting at ${selectedProduct?.Sizes[0]?.ColoredPrice} USD
                </p>
              </Card>
            </CardWrapper>
          );
        })}
      </Slider>
      <DetailSection>
        <Description>
          <h4>{selectedProduct?.Product?.DisplayName}</h4>
          <div
            dangerouslySetInnerHTML={{
              __html: selectedProduct?.Product?.Description,
            }}></div>
        </Description>
        <StyledColor>
          <h4>Colors Available</h4>
          <ColorWrapper>
            {selectedProduct?.Colors.map((color, index) => (
              <Color
                onClick={() =>
                  setSelectedProduct({
                    ...selectedProduct,
                    Product: {
                      ...selectedProduct.Product,
                      MarketingImagePath: color.Image,
                    },
                  })
                }
                title={color.Name}
                code={color.HexCode}
                key={`colorFilter${index}`}
              />
            ))}
          </ColorWrapper>
          <h4>Sizes Available</h4>
          <Size>
            {selectedProduct?.Sizes.map((size, index) => (
              <div key={`sizes${index}`}>{size.Name}</div>
            ))}
          </Size>
          <Button
            containerStyle={{
              backgroundColor: '#000',
              fontSize: '13px',
              borderRadius: '50px',
              padding: '7px 12px',
              lineHeight: '1.5',
              color: '#fff',
              margin: '30px 0 20px',
              width: '100%',
              fontWeight: '700',
            }}
            variant='text'
            title='Sign up for exact pricing'
            onClick={() =>
              _.isFunction(toggleSignUpDialog()) && toggleSignUpDialog()
            }
          />
        </StyledColor>
      </DetailSection>
    </div>
  );
};

export default ProductDetails;
